import { LocationChecklistService } from './../../services/location-checklist/location-checklist.service';
import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { NgForm } from '@angular/forms';
import { FormBuilder, FormGroup, FormArray, FormControl, ValidatorFn } from '@angular/forms';
import { documentInformation } from '../../model/document.model';
import * as momenttimezone from 'moment-timezone';
import { UploadService } from '../../services/upload/upload.service';
import { SharedVals } from '../../../shared/SharedVals';


@Component({
  selector: 'app-agent-checklist',
  templateUrl: './agent-checklist.component.html',
  styleUrls: ['./agent-checklist.component.css']
})
export class AgentChecklistComponent implements OnInit {
  form: FormGroup;
  private agentId: any;
  private LocationId: any;
  private loginId: any;
  submitSuccess: boolean;
  message: string;
  DocTypeErrMsg: string;
  DocTypeErr: boolean;
  errMsg: any;
  errFlag: boolean;
  clientDisable: boolean = false;
  clientHidden: boolean = false;
  venodr_client: boolean = false;
  public role: string;
  matSpinner: boolean;
  uploadFlag: boolean = true;
  isFileChanged: boolean = false;
  errorEnable: boolean = false;
  newFilePath1;
  signedUrl;
  externalURL: any;
  errorMessage: String = '';
  filePath: string;
  documentInfo: documentInformation = new documentInformation();
  cdsFile;
  gsFile;
  ksFile;
  fpFile;
  ssFile;
  oppFile;
  cdsFileName;
  gsFileName;
  ksFileName;
  fpFileName;
  ssFileName;
  oppFileName;
  fileCategoryShortName: string;
  cdsHideFile: boolean = true;
  gosHideFile: boolean = true;
  fpHideFile: boolean = true;
  ssHideFile: boolean = true;
  ksHideFile: boolean = true;
  ppHideFile: boolean = true;

  data = {
    fileName: '',
    fileCategory: '',
    InspectedDate: '',
    confirmAddress: false,
    systemsProtected: false,
    picturesOfFence: false,
    customerInformation: false,
    systemsEncryption: false,
    Notes: '',
    CDSDescription: '',
    CDSDocumentName: '',
    CDSDocumentLink: '',
    GSDescription: '',
    GSDocumentName: '',
    GSDocumentLink: '',
    FPDescription: '',
    FPDocumentName: '',
    FPDocumentLink: '',
    SSDescription: '',
    SSDocumentName: '',
    SSDocumentLink: '',
    KSDescription: '',
    KSDocumentName: '',
    KSDocumentLink: '',
    PPDescription: '',
    PPDocumentName: '',
    PPDocumentLink: '',
    fireExtinguisher: false,
    shreddingDocument: false,
    keyStorage: false,
    personalStorage: false,
    personalPropertyRemoved: false,
    noGuardAllowed: false
  }

  constructor(private checklist: LocationChecklistService,
    public ref: ChangeDetectorRef,
    private uploadService: UploadService,
    public sharedVals: SharedVals) {
  }

  ngOnInit() {
    this.agentId = localStorage.getItem("AgentId");
    this.LocationId = localStorage.getItem("LocationId");
    this.loginId = localStorage.getItem("loginID");
    this.getChecklistData();
    this.sharedVals.roleData.subscribe(data => {
      this.role = data;
      if (this.role === "PC Client") {
        this.clientDisable = true;
        this.clientHidden = true;
        this.venodr_client = true;
      } else {
        this.clientDisable = false;
        this.clientHidden = false;
        this.venodr_client = false;
      }
    }, err => {
      
    });    
  }

  getChecklistData() {
    this.checklist.getLocationChecklist(this.LocationId, this.agentId).subscribe(res => {
      if (res !== undefined && res !== '') {
        if (res.SiteInspectionInfo !== undefined && res.SiteInspectionInfo.length > 0) {
          res.SiteInspectionInfo.forEach(locationData => {
            this.cdsFile = locationData.ComputerDataSecurity.CDSDocumentLink !== "" ? locationData.ComputerDataSecurity.CDSDocumentLink : this.cdsFile;
            this.gsFile = locationData.Gated_or_Secured.GSDocumentLink !== "" ? locationData.Gated_or_Secured.GSDocumentLink : this.gsFile;
            this.ksFile = locationData.KeyStorage.KSDocumentLink !== "" ? locationData.KeyStorage.KSDocumentLink : this.ksFile;
            this.fpFile = locationData.FireProtection.FPDocumentLink !== "" ? locationData.FireProtection.FPDocumentLink : this.fpFile;
            this.ssFile = locationData.ShreddingSystem.SSDocumentLink !== "" ? locationData.ShreddingSystem.SSDocumentLink : this.ssFile;
            this.oppFile = locationData.PersonalProperty.PPDocumentLink !== "" ? locationData.PersonalProperty.PPDocumentLink : this.oppFile;

            this.cdsFileName = locationData.ComputerDataSecurity.CDSDocumentName;
            this.gsFileName = locationData.Gated_or_Secured.GSDocumentName;
            this.ksFileName = locationData.KeyStorage.KSDocumentName;
            this.fpFileName = locationData.FireProtection.FPDocumentName;
            this.ssFileName = locationData.ShreddingSystem.SSDocumentName;
            this.oppFileName = locationData.PersonalProperty.PPDocumentName;

            this.allFileNames.forEach(file => {
              switch (file.Category) {
                case 'ComputerDataSecurity':
                  file.FileName = this.cdsFileName
                  file.documentLink = this.cdsFile;
                  break;
                case 'GatedSecured':
                  file.FileName = this.gsFileName
                  file.documentLink = this.gsFile;
                  break;
                case 'KeyStorage':
                  file.FileName = this.ksFileName
                  file.documentLink = this.ksFile;
                  break;
                case 'FireProtection':
                  file.FileName = this.fpFileName
                  file.documentLink = this.fpFile;
                  break;
                case 'ShreddingSystem':
                  file.FileName = this.ssFileName
                  file.documentLink = this.ssFile;
                  break;
                case 'OrganizedPersonalProperty':
                  file.FileName = this.oppFileName
                  file.documentLink = this.oppFile;
                  break;
              }
            })
            this.data.InspectedDate = (locationData.InspectedDate == null) ? '' : locationData.InspectedDate;
            this.data.confirmAddress = (locationData.ConfirmAddress != 'No');

            this.data.systemsProtected = (locationData.ComputerDataSecurity.PasswordProtected != 'No');
            this.data.systemsEncryption = (locationData.ComputerDataSecurity.DevicesEncrypted != 'No');
            this.data.customerInformation = (locationData.ComputerDataSecurity.IsCustomerInfoPresent != 'No');
            this.data.CDSDescription = locationData.ComputerDataSecurity.CDSDescription;
            this.data.CDSDocumentName = locationData.ComputerDataSecurity.CDSDocumentName;
            this.data.CDSDocumentLink = this.cdsFile;

            this.data.picturesOfFence = (locationData.Gated_or_Secured.Is_Gated_or_Secured != 'No');
            this.data.GSDescription = locationData.Gated_or_Secured.GSDescription;
            this.data.GSDocumentName = locationData.Gated_or_Secured.GSDocumentName;
            this.data.GSDocumentLink = this.gsFile;

            this.data.keyStorage = (locationData.KeyStorage.IsKeyStorage != 'No');
            this.data.KSDescription = locationData.KeyStorage.KSDescription;
            this.data.KSDocumentName = locationData.KeyStorage.KSDocumentName;
            this.data.KSDocumentLink = this.ksFile

            this.data.fireExtinguisher = (locationData.FireProtection.IsFireProtection != 'No');
            this.data.FPDescription = locationData.FireProtection.FPDescription;
            this.data.FPDocumentName = locationData.FireProtection.FPDocumentName;
            this.data.FPDocumentLink = this.fpFile;

            this.data.shreddingDocument = (locationData.ShreddingSystem.IsShreddingSystem != 'No');
            this.data.SSDescription = locationData.ShreddingSystem.SSDescription;
            this.data.SSDocumentName = locationData.ShreddingSystem.SSDocumentName;
            this.data.SSDocumentLink = this.ssFile;

            this.data.personalStorage = (locationData.PersonalProperty.PPStorage != 'No');
            this.data.personalPropertyRemoved = (locationData.PersonalProperty.PPRemoved != 'No');
            this.data.PPDescription = locationData.PersonalProperty.PPDescription;
            this.data.PPDocumentName = locationData.PersonalProperty.PPDocumentName;
            this.data.PPDocumentLink = this.oppFile;

            this.data.Notes = locationData.Notes;
            this.data.noGuardAllowed = (locationData.DogsAllowed != 'No');
          });
        } else {
          this.errMsg = "No Requests data found ";
          this.DocTypeErr = true;
        }
      } else {
        this.errMsg = "No Requests data found ";
        this.DocTypeErr = true;
      }
    }, err => {
      this.errMsg = "CheckList Service " + err;
      this.DocTypeErr = true;
    });
  }

  allFileNames = [
    { Category: 'ComputerDataSecurity', FileName: '', documentInfo: null, documentLink: null, locationName: 'CDS' },
    { Category: 'GatedSecured', FileName: '', documentInfo: null, documentLink: null, locationName: 'GOS' },
    { Category: 'KeyStorage', FileName: '', documentInfo: null, documentLink: null, locationName: 'KS' },
    { Category: 'FireProtection', FileName: '', documentInfo: null, documentLink: null, locationName: 'FP' },
    { Category: 'ShreddingSystem', FileName: '', documentInfo: null, documentLink: null, locationName: 'SS' },
    { Category: 'OrganizedPersonalProperty', FileName: '', documentInfo: null, documentLink: null, locationName: 'PP' },
  ];

  setFileData(docInfo, type) {
    setTimeout(() => {
      if (type === 'ComputerDataSecurity') {
        this.cdsHideFile = false;
      } else if (type === 'GatedSecured') {
        this.gosHideFile = false;
      } else if (type === 'KeyStorage') {
        this.ksHideFile = false;
      } else if (type === 'FireProtection') {
        this.fpHideFile = false;
      } else if (type === 'ShreddingSystem') {
        this.ssHideFile = false;
      } else if (type === 'OrganizedPersonalProperty') {
        this.ppHideFile = false;
      }
      this.documentInfo = docInfo;
      this.data.fileName = this.documentInfo.fileName;
      this.data.fileCategory = this.documentInfo.fileCategory;
      this.getDocumentLink();
      this.allFileNames.forEach(file => {
        if (this.data.fileCategory === file.Category) {
          file.FileName = this.data.fileName;
          file.documentInfo = docInfo;
        }
      })
      this.ref.markForCheck();
      this.ref.detectChanges()
    }, 100);
    this.isFileChanged = true;
  }

  getDocumentLink() {

    let today = new Date();
    const estTimeZone = 'America/New_York';
    let uploadTimeZone = momenttimezone(today).tz(estTimeZone).format();
    uploadTimeZone = uploadTimeZone.replace(/[^a-zA-Z0-9]/g, '');
    this.allFileNames.forEach(file => {
      if (this.data.fileCategory === file.Category) {
        this.fileCategoryShortName = file.locationName;
        this.filePath = "Agent/" + this.agentId + "/location_siteinspection/" + this.LocationId + "/" + this.fileCategoryShortName + "/";
      }
    })
    this.data.fileName = this.documentInfo.fileName;
    let fileNameWithoutExt = this.documentInfo.fileName.substring(0, this.documentInfo.fileName.lastIndexOf('.'));
    let fileNameExt = this.documentInfo.fileName.substring(this.documentInfo.fileName.lastIndexOf('.') + 1, this.documentInfo.fileName.length);
    this.documentInfo.fileInput.append('url', this.filePath + fileNameWithoutExt + '_' + uploadTimeZone + '.' + fileNameExt);
    this.newFilePath1 = this.filePath + fileNameWithoutExt + '_' + uploadTimeZone + '.' + fileNameExt;
    this.allFileNames.forEach(file => {
      if (this.data.fileCategory === file.Category) {
        this.externalURL = this.newFilePath1;
        file.documentLink = this.externalURL
      }
    })
    let body = {
      "newFilePath": this.newFilePath1,
      "vendor_id": this.agentId
    }
    this.uploadService.getSignedURL(body).subscribe((res) => {

      this.signedUrl = res.Info;
      this.uploadService.uploadDocumentWithSignedUrl(this.documentInfo.file, this.signedUrl).subscribe((obj) => {
        this.externalURL = this.newFilePath1;

      });
    }, error => {
      this.errorEnable = true;
      this.errorMessage = "File upload: " + error;
      this.matSpinner = false;
    });

  }

  onFormSubmit(form: NgForm) {
    this.matSpinner = true;
    this.uploadFlag = false;
    const editLocalData = form.value;
    this.checklist.saveLocationChecklist(editLocalData, this.LocationId, this.loginId, this.agentId, this.allFileNames).subscribe(res => {
      if (res.Status == 200 || res.Status == 201) {
        this.submitSuccess = true;
        this.DocTypeErr = false;
        this.matSpinner = false;
        this.message = 'Information Submitted successfully';
      }
    }, err => {
      this.DocTypeErrMsg = 'CheckList Service' + ' ' + err;
      this.DocTypeErr = true;
      this.matSpinner = false;
      this.submitSuccess = false;
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/agent-checklist/agent-checklist.component.ts